module.exports = require("lodash/toPlainObject");